module.exports = __webpack_public_path__ + "media/images/plane-b17359c0.jpg";